import React, { useMemo } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import {
  DATE_FORMAT,
  TIME_FORMAT,
  parseClockTime,
  serializeClockTime,
} from "../../../../utils/formatTime";

interface PickupDateTimeProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
  time: string | null;
  setTime: (time: string | null) => void;
  dateError?: string;
  timeError?: string;
}

const PickupDateTime: React.FC<PickupDateTimeProps> = ({
  date,
  setDate,
  time,
  setTime,
  dateError,
  timeError,
}) => {
  const timeValue = useMemo(() => parseClockTime(time), [time]);

  return (
    <Box sx={{ mb: 2, width: "100%", p: 1 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Pickup
      </Typography>
      <Stack direction="row" spacing={3} alignItems="flex-start">
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography variant="body1" sx={{ mr: 2 }}>
            Date:
          </Typography>
          <DatePicker
            value={date}
            onChange={setDate}
            format={DATE_FORMAT}
            sx={{ width: "100%" }}
            slotProps={{
              textField: {
                fullWidth: true,
                required: true,
                error: !!dateError,
                helperText: dateError,
              },
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography variant="body1" sx={{ mr: 2 }}>
            Time:
          </Typography>
          <TimePicker
            value={timeValue}
            onChange={(value) => setTime(serializeClockTime(value))}
            format={TIME_FORMAT}
            ampm
            sx={{ width: "100%" }}
            slotProps={{
              textField: {
                fullWidth: true,
                required: true,
                error: !!timeError,
                helperText: timeError,
              },
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default PickupDateTime;
